import React from 'react';
import './about.css';
import { Link } from 'react-router-dom';
import Resume from '../images/resume.pdf';

const About = () => {
  return (
    <div className="about-main">
      <p className="about-headline">
        I'm a software developer (React, JavaScript, Ruby on Rails)
        who loves engaging creatively with complex problems.
      </p>
      <p className="about-description">
        I came to software development from a career as a jazz saxophonist
        and clarinetist focused on creative improvisational music.
        Though the context has changed, I'm still cultivating my passion
        to compose, create, and improvise solutions in code to whatever
        complex problems I encounter. <br></br> <br></br> My latest projects are
        SongCabin, a single-page, BandCamp-inspired web app for
        uploading and playing music, created with React, Redux, and
        Rails; and Lollygag Looper, a JavaScript-based music-looping
        app utilizing the Tone.js library.
      </p>
      <p className="resume">
        <a href={Resume} target="_new">
          Resume
        </a>
      </p>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.jsx